module.exports = __webpack_public_path__ + "img/topFeature2.9713148.png";